import { instance } from "../axios";

// Fetch the list of files for a specific study
export const getFilesByStudyId = async (studyId) => {
  try {
    const response = await instance.get(`file/list-files/${studyId}`);
    console.log("Response from getFilesByStudyId:", response.data.files);
    return { files: response.data.files }; 
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      console.error(`The big Error is: ${error.response.data.error}`);
      return { error: error.response.data.error };
    }
    console.error("Unexpected error fetching files:", error);
    return { error: "An unexpected error occurred. Please try again later." }; 
  }
};

// Download a specific file
export const downloadFile = async (studyId, fileName) => {
  try {
    const response = await instance.get(`file/${studyId}/${fileName}`, {
      responseType: "blob", // binary data
    });

    // Create blob URL
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url); // Clean up the blob URL
  } catch (error) {
    console.error("Error downloading file:", error);
    throw error;
  }
};